import { useTranslation } from 'react-i18next';
import { Icon, TextInput } from '@socialchorus/shared-ui-components';
import {
  MAXIMUM_TITLE_LENGTH,
  useUserGeneratedContent,
} from '../../../../models/user-generated-contents/context';
import '../form.scss';

const TITLE_ERROR_ID = 'ugc-title-error';

const TitleInput = () => {
  const {
    userGeneratedContent,
    isPersisting,
    updateUserGeneratedContentFormState,
    memberValidationErrors,
  } = useUserGeneratedContent();
  const { t } = useTranslation();

  const onTextChange = (title: string) => {
    updateUserGeneratedContentFormState({ title });
  };

  const showError = memberValidationErrors.title;

  return (
    <div className="ugc__editor-input-wrapper ugc__editor-input-wrapper-title">
      <TextInput
        placeholder={t('user_generated_content.field_title_placeholder')}
        fullWidth
        value={userGeneratedContent.title || ''}
        onChange={onTextChange}
        disabled={isPersisting}
        className={'ugc__title-input-fieldset'}
        maxLength={MAXIMUM_TITLE_LENGTH}
        inputClassName={'ugc__title-input'}
        variant="borderless"
        aria-label={t('user_generated_content.field_title')}
        aria-invalid={showError || undefined}
        aria-describedby={showError ? TITLE_ERROR_ID : undefined}
        aria-errormessage={showError ? TITLE_ERROR_ID : undefined}
        showCharacterCounter
      />
      {showError && (
        <div id={TITLE_ERROR_ID} role="alert" className="ugc__validation-error">
          <Icon size={16}>warning</Icon>
          <span className="text-caption">
            {t('user_generated_content.validation.title_required')}
          </span>
        </div>
      )}
    </div>
  );
};

export default TitleInput;
